import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  style: {"width":"100px","margin":"auto","margin-top":"200px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", { type: "text" }, null, -1)

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';
import { useAppContext } from '@/app/_tech'
import { Guid } from '@/lib';
import { symlinkSync } from 'fs';
import sys from '@/sys';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {




const router = useRouter();
const context = useAppContext();

const { authenticated } = context;

const error = ref('');



function navigatePerson(wid: Guid, nid: Guid) {

  wid.toString()
  nid.toString();
}


function navigateProject(wid: Guid, pid: Guid) {

  try {

    pid.toString();

    context.storages.workspace = context.service.workspaceStorage(wid);

    router.push('/workspace') //? match to wid?

  } catch (error) {

    sys.exception(error)

  }


}

//authenticateUser
function authenticate() {

  //empty login-pass make system grab the latest account when server setup in 'dev' mode
  context.authenticate("", "").then((result: boolean) => {

    if (result) {

      console.log(`/home.vue - Authenticatd successfully`); //#DEV/TRACING

      error.value = '';

      // eslint-disable-next-line
      if (false) {


        //display /home screen with listed workspaces;
        //if workspace is sinle - redirect to iod or last worked on

        const wid = Guid.newGuid() as Guid;

        navigateProject(wid, wid);
      }
    }
    else {
      //display error warning
      error.value = "[Authentication:Failure]" //#literal
    }
  })
}



onMounted(() => {
  console.log(`/Home.vue - Authenticated:${context.authenticated.value}`) //#DEV/TRACING
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (error.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (_unref(authenticated))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, "Workspaces: " + _toDisplayString(_unref(context).model.workspaces.length), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(context).model.workspaces, (w) => {
            return (_openBlock(), _createElementBlock("div", {
              key: w.wid.toString()
            }, [
              _createElementVNode("p", null, [
                _createVNode(_component_router_link, {
                  to: { name: 'project', params: { workspace: w.name, project: '' }, }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Name:" + _toDisplayString(w.name) + " Wid: " + _toDisplayString(w.wid), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _createElementVNode("p", null, [
                _createTextVNode("Projects: "),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.projects, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "mn-link",
                    onClick: ($event: any) => (navigateProject(w.wid, p.pid)),
                    key: p.pid.toString()
                  }, _toDisplayString(p.name), 9, _hoisted_3))
                }), 128))
              ]),
              _createTextVNode(" Projects: "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.projects, (p) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: p.pid.toString()
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'project', params: { workspace: w.name, project: p.name }, }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128)),
              _createTextVNode(" Persons: "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.persons, (p) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: p.nid.toString()
                }, [
                  _createVNode(_component_router_link, {
                    to: { name: 'person', params: { workspace: w.name, person: p.name }, }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(p.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(context).logoff()))
          }, "OFF")
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", { onClick: authenticate }, "Login")
        ]))
  ]))
}
}

})